import { Scrollable } from 'components/scrollable'
import { useUrl } from 'hooks/useUrl'
import { useRouter } from 'next/router'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { stringifyQueryObject } from 'utils/query'
import { RoleModel } from 'utils/role'
import { Bathrooms } from './bathrooms'
import { Bedrooms } from './bedrooms'
import { Budget } from './budget'
import { Details } from './details'
import { MapToggle } from './map-toggle'

const Wrapper = styled(Scrollable)`
  position: fixed;
  height: 60px;
  left: 0;
  right: 0;
  top: 70px;
  z-index: 1000;
  background: #f8f9fa;
  box-shadow: 0 1px 0 0 rgba(229, 232, 236, 0.5);
  overflow: auto;

  ${up('sm')} {
    overflow: unset;
    height: 70px;
  }
`

const Content = styled.div`
  display: flex;
  height: 60px;
  align-items: center;
  margin: 0 -4px;

  ${up('sm')} {
    height: 70px;
  }
`

interface ItemProps {
  order: number
  desktopOrder: number
  push?: boolean
}

const Item = styled.div<ItemProps>`
  padding: 0 4px;
  margin-right: ${({ push }) => push && 'auto'};
  order: ${({ order }) => order};

  ${up('sm')} {
    order: ${({ desktopOrder }) => desktopOrder};
  }
`

interface Props {
  role?: RoleModel
}

export const Toolbar: ComponentType<Props> = ({ role }) => {
  const router = useRouter()
  const { url, query } = useUrl()

  const handleSubmit = (changes: any) => {
    router.push(
      router.route,
      {
        pathname: url.pathname,
        search: stringifyQueryObject(query, changes, { page: '' }),
      },
      {
        shallow: true,
      },
    )
  }

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Content>
              <Item order={2} desktopOrder={1}>
                <Bedrooms query={query} onSubmit={handleSubmit} />
              </Item>
              <Item order={3} desktopOrder={2}>
                <Bathrooms query={query} onSubmit={handleSubmit} />
              </Item>
              <Item order={4} desktopOrder={3}>
                <Budget query={query} onSubmit={handleSubmit} disabled={!role} />
              </Item>
              <Item order={5} desktopOrder={4} push>
                <Details query={query} onSubmit={handleSubmit} />
              </Item>
              <Item order={1} desktopOrder={5}>
                <MapToggle query={query} onSubmit={handleSubmit} />
              </Item>
            </Content>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}
